import { App, Plugin } from "vue";
import PrimeVue from "primevue/config";
import createPreset from "./theme";
import useTheme from "./Hook/useTheme";

/*
 | AppSetup: installs PrimeVue with the site-driven theme. The brand colours
 | from `site.settings` (shared on the initial Inertia page) are expanded into
 | Aura's primary/secondary token scales via useTheme().defineTheme() — the
 | same mechanism as www. Falls back to the plain Aura preset if a colour
 | setting is malformed, so a bad value can never white-screen the app.
 */
const AppSetup: Plugin = {
    install(app: App, options?: { props?: any }) {
        let preset;

        try {
            const { defineTheme } = useTheme(options?.props?.initialPage?.props);
            preset = createPreset(defineTheme());
        } catch (err) {
            console.error("Theme preset build failed; using default Aura.", err);
            preset = createPreset();
        }

        app.use(PrimeVue, {
            theme: {
                preset,
                options: {
                    darkModeSelector: "app",
                },
            },
        });
    },
};

export default AppSetup;
